<template>
  <div class="ios-rule">
    <h1>才博会员服务使用协议</h1>
    <p>感谢您选择才博会员服务！本协议是您与才博之间关于用户使用才博会员服务所订立的协议。在使用本服务前，请您务必审慎阅读、充分理解各条款内容，特别是限制或免除责任的相应条款，以及开通或使用某项服务的单独协议，并选择接受或不接受。限制或免除责任条款可能以加粗形式提示您注意。 除非您已阅读并接受本协议所有条款，否则您无权使用本软件及本服务。您对本服务的购买、登陆、查看等任何使用行为均视为您已阅读并同意受本协议的约束。</p>
    <h2>（一）定义</h2>
    <p>1.“才博会员服务”/“本服务”，是用户按照才博的指定方式支付一定增值服务费用之后，用户可以享有由才博或第三方合作伙伴提供的在产品等方面特权的服务。才博可能会根据不同的产品及服务类型，推出不同的会员服务，同时，才博也可能会根据用户的需求、产品及服务类型的变化等，对现有会员服务种类进行调整以及不断推出新的会员服务种类。才博会员服务的具体种类、内容由才博根据实际情况提供。才博仅许可用户在中华人民共和国大陆范围（不包含香港特别行政区、澳门特别行政区及台湾地区, 以下简称中国大陆）内使用才博会员服务。</p>
    <p>2.“登录账号”，指您用于登录本服务（或本服务包含的任何子服务）的才博通行证账号或第三方账号（第三方账号包括但不限于目前的QQ/新浪微博/小米账号及后续可能增加的其他第三方账号）。您在注册才博通行证账号以外的登录账号时需完全根据该登录账号提供方（例如登录账号系QQ账号，则该账号的登录账号提供方系腾讯，以此类推，本协议凡提及登录账号提供方指除才博通行证账号以外的其他登录账号的提供方）的相关要求进行。
    </p>
    <p>3.“您”/“用户”，是指使用本服务的自然人用户，且仅限自然人用户在阅读并接受本协议及本服务包含的子服务附带的相关协议、相关业务规则等（如有）的全部条款后方可免费或付费使用本服务包含的该项子服务，任何非自然人用户（包括任何具备或不具备法人主体资格的机构或组织）在任何情况下均不得以任何方式使用本服务或本服务包含的任何子服务。
    </p>
    <p>4.“才博”，是指“珠海金山办公软件有限公司”旗下才博业务。
    </p>
    <h2>二）接受本协议
    </h2>
    <p>1.您在使用本服务时，应当遵守相关协议、相关业务规则。如果您不接受本协议的全部或任何部分条款，则您均无权使用本服务的任何部分或全部。
    </p>
    <p>2.即便您没有点击同意本协议，下述行为也将视为您对本协议的认可：
    </p>
    <p>2.1.点击登录本服务，该登录行为将视为您对本协议的完全同意；</p>
      <p>2.2.实际使用本服务，该使用行为将视为您对本协议的完全同意；</p>
     <p>2.3.实际使用才博连同本服务一并提供的任何产品或服务（如有），该使用行为将视为您对本协议的完全同意。</p>
      <p>2.4.实际使用第三方连同本服务一并提供的任何产品或服务（如有），该使用行为将视为您对本协议的完全同意。</p>
  <p>3.您继续之前，才博强烈建议您打印或在本地保存本协议作为备案。</p>
    <p>4.您对本协议的同意即视为您已知悉并同意本协议全部条款并且您保证能够完全遵守本协议。
    </p>
    <h2>（三）服务费用
    </h2>
    <p>1.本服务以收费方式提供，本服务服务费用以人民币计费。服务费用通过第三方支付渠道收取，支付渠道包括目前已开通的支付宝支付、微信支付以及未来可能增加的其他支付渠道。
    </p>
    <p>2.才博可能根据实际运营情况对本服务服务费用的收费模式、收费标准、方式进行修改和变更，才博也可能会对本服务目前提供的免费部分开始收费。前述修改、变更或开始收费前，才博将在相应服务页面进行通知或公告。如果您不同意上述修改、变更或付费内容，则应停止使用该部分服务。</p>
    <p>3.您应当理解，您所向才博所支付的服务费用不包含因您为使用本服务而配备软硬件以及带宽等产生的费用以及您访问互联网或移动网络而产生的相关费用，您使用才博提供的本服务需自行准备与本服务有关的终端设备（如电脑、调制解调器等装置），您使用本服务时会耗用您的终端设备和带宽等资源，且您均应自行承担因使用本服务而需向包括网络运营商在内的第三方支付的相关费用，例如，软硬件购置费、带宽费用、电话费、手机短信费（如有）等。
    </p>
    <p>4. 服务续费与停缴：用户所订购的本服务的服务期限届满前30天、7天以及当天，才博均将通过相应方式提示用户进行续费。用户在其所订购的本服务的服务期限届满之日仍未进行续费的，自其所订购的本服务的服务期限届满次日起才博将终止向用户提供才博会员服务的任何部分或全部，因服务期限届满终止才博会员服务而给用户造成的任何损失，才博不承担任何法律责任。</p>
    <h2>（四）本服务的开通、中止、终止及转让
    </h2>
    <p>1.服务的开通
    </p>
    <p>用户完成才博会员服务费的支付后即获得才博会员资格，才博会员服务期限自才博会员服务开通之日起算。
    </p>
    <p>2.服务的中止
    </p>
    <p>
      2.1.为了本服务的正常运行，才博有权定期或不定期地进行维护，包括但不限于对本服务相关网站不时进行维护，因此类情况而造成的正常服务中断，您应该予以理解，才博将尽合理努力事先进行通告，并尽力避免服务中断或将中断时间限制在最短时间内；但对因此产生的不便和损失，才博不承担责任。
      <br>
      2.2.如发生下列任何一种情形，才博有权随时中断向您提供本协议项下的服务而无需通知您，对因此而产生的不便或损害，才博对您或第三人均不承担任何责任： <br>
      2.2.1.定期检查或施工，更新软硬件等，才博有权暂停服务，但才博会尽快完成维护、更新工作；<br>
      2.2.2.服务器遭受损坏，无法正常运作；<br>
      2.2.3.突发性的软硬件设备与电子通信设备故障；<br>
      2.2.4.网络提供商线路或其它故障；<br>
      2.2.5.在紧急情况之下为维护国家安全或其它第三者之人身安全；<br>
      2.2.6.不可抗力及其他第三方原因；<br>
      2.2.7.才博怀疑您存在有违法之虞或损害第三人合法权益之虞的行为或可能导致才博被追究责任的行为，或才博已收到第三方发来的知识产权侵权投诉。<br>
    </p>
  <p>3.服务的终止
  </p>
  <p>如用户违反才博的相关规定（包括但不限于本协议）或违反适用的相关法律法规，才博有权立即取消对该用户提供的本服务的部分或全部，亦有权查封您的登录账号令您不能再使用本服务包含的任何子服务。请您严格依照才博相关规定及适用的相关法律法规使用本服务，因您的违约或违法行为而导致才博取消部分或全部本服务的，或导致才博查封您的登录账号的，由此导致您或第三方遭受任何损失（包括但不限于导致您在使用本服务过程中存储的全部文件信息内容丢失、毁损）才博均不承担任何责任，且才博无义务为您或第三方提供任何内容恢复或备份服务。</p>
  <p>4.服务的转让</p>
  <p>本服务仅供您自行使用，您在任何时候均无权以任何方式将本服务包含的任何部分或全部予以转让、转授权、分授权给您以外的任何一方。如本款约定与本协议其他条款约定发生冲突均以本款约定为准。</p>
  <h2>（五）其他</h2>
  <p>本协议的订立、执行和解释及争议的解决均应适用中国法律。</p>
  <p>如双方就本协议内容或其执行发生任何争议，双方应尽量友好协商解决；协商不成时，您和才博一致同意交由才博所在地有管辖权的法院管辖。
    用户对本服务之任何部分或本协议的任何部分之意见及建议可通过客户服务部门与才博联系。</p>
  </div>

</template>

<script>
export default {
  computed: {
  },
  methods: {
  },
  beforeCreate () {
  },
  created () {
  },
  beforeDestroy () {
  },
  components: {

  }
}
</script>

<style lang="scss">
@charset "UTF-8";
@import "../../style/main";

.ios-rule {
  line-height: 2;
  font-size: rem(22);
  padding: rem(10);
  h1 {
    text-align: center;
    font-size: rem(26);
  }
  h2, p {
    text-align: left;
  }
}
</style>
